import React from 'react'
import LoadingSpinner from '../../../components/common/LoadingSpinner'
import { usePostRequest } from '../../../shared/hooks/requests'
import { useMessage } from '../../../shared/hooks/message'
import { EmptyFolderIcon } from '../../../components/svgs/Svgs'

export function Card({ count, title, btntitle, loading, ids, url }) {
    const showMessage = useMessage()
    const postIds = usePostRequest()

    const submit = async () => {
        if (url !== undefined) {
            const { success } = await postIds.request({
                url,
                data: {
                    tenant_entity_ids: ids,
                },
            })
            if (success) {
                showMessage('successfully send', 'success-msg')
            }
        } else {
            showMessage('Yuborish hali tayyormas', 'error-msg')
        }
    }
    return (
        loading ? (
            <div className="w-full h-auto py-[20px] bg-white rounded-[10px] flex flex-col items-center justify-center">
                <LoadingSpinner />
            </div>
        ) : (
            (count === 0 || (Array.isArray(count) && count.length === 0)) ? (
                <div className="w-full h-full bg-white flex flex-col items-center justify-center">
                    <EmptyFolderIcon />
                </div>
            ) : (
                <div className="w-full h-auto flex items-center
             justify-between px-[15px] py-[20px] bg-white rounded-[10px]"
                >
                    <span className="text-[16px] text-center font-[500] text-black/60">{title}</span>
                    <span className="text-[15 px] font-[700] text-black">{count === 0 ? 0 : count}</span>
                    <button
                        onClick={submit}
                        className="text-[14px] px-[15px] text-center py-[10px]
            rounded-[6px] bg-main-300 text-white font-[500]"
                    >
                        {btntitle}
                    </button>
                </div>
            )
        )
    )
}
